import React from 'react';
import { useTranslation } from 'react-i18next';
import { COLORS } from '../utils/constants';

const LANGUAGES = [
  { code: 'es', flag: '🇪🇸', label: 'ES' },
  { code: 'de', flag: '🇩🇪', label: 'DE' },
  { code: 'en', flag: '🇬🇧', label: 'EN' },
  { code: 'it', flag: '🇮🇹', label: 'IT' },
  { code: 'fr', flag: '🇫🇷', label: 'FR' },
  { code: 'tr', flag: '🇹🇷', label: 'TR' },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const current = i18n.language?.slice(0, 2) || 'es';

  return (
    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
      {LANGUAGES.map(lang => (
        <button
          key={lang.code}
          onClick={() => i18n.changeLanguage(lang.code)}
          style={{
            padding: '5px 9px',
            borderRadius: 8,
            border: `1px solid ${current === lang.code ? COLORS.accent : COLORS.border}`,
            background: current === lang.code ? `${COLORS.accent}20` : 'transparent',
            color: current === lang.code ? COLORS.accent : COLORS.textMuted,
            fontSize: 11,
            fontWeight: 700,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: 4,
          }}
        >
          <span>{lang.flag}</span>
          <span>{lang.label}</span>
        </button>
      ))}
    </div>
  );
}
